// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"e20fe712","453":"71e15b41"}[chunkId] + ".chunk.js";
};